import { Link } from "react-router";

import { PageHeader } from "../components/shell/AppShell";
import { AlertBanner } from "../components/ui/Feedback";

export function ForbiddenPage() {
  return (
    <div className="page">
      <PageHeader title="Yetki yok" />
      <AlertBanner heading="Bu işlem için yetkiniz yok" tone="warning">
        <p>Erişim gerekiyorsa bir owner veya yöneticiyle iletişime geçin.</p>
        <Link to="/genel-bakis">Genel Bakış’a dön</Link>
      </AlertBanner>
    </div>
  );
}
